import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { shopApi } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function MockPayPal() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const complete = async () => {
    setLoading(true);
    try {
      await shopApi.completePayPal(orderId);
      nav(`/order/success?session_id=paypal_${orderId}&order_id=${orderId}`);
    } catch { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto py-24 text-center px-4">
      <div className="rounded-2xl bg-card border-2 border-primary/40 p-8">
        <div className="inline-block px-3 py-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold uppercase tracking-widest mb-4">
          Demo mode · no real charge
        </div>
        <div className="text-3xl mb-4"><span className="font-bold text-[#003087]">Pay</span><span className="font-bold text-[#009cde]">Pal</span></div>
        <p className="text-sm text-muted-foreground mb-6">
          PayPal is <span className="text-white font-semibold">not configured</span> in this environment, so this is a simulated checkout.
          <br /><br />
          Click below to simulate a successful payment — <strong>no real money will move.</strong>
        </p>
        <Button className="btn-primary w-full h-12" onClick={complete} disabled={loading} data-testid="mock-paypal-confirm">
          {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null} Confirm demo payment
        </Button>
        <Button variant="outline" className="border-white/15 w-full mt-2 h-12" onClick={() => nav("/checkout")} data-testid="mock-paypal-cancel">
          Cancel and go back
        </Button>
        <p className="text-[11px] text-muted-foreground mt-5">To test real PayPal, use your <strong>production site</strong> — this preview environment intentionally has no PayPal keys.</p>
      </div>
    </div>
  );
}
